export const BLINGS_COLOR = "#ff3666";
export const GRAY_COLOR = "#ADADAD";
export const WHITE80 = "#FFFFFFcc";
export const WHITE40 = "#FFFFFF66";
